// 관리자 Preview는 HERO_PREVIEW_MODES의 내부 조합을 복제하지 않는다.
// 실제 Production 홈에서 사용자에게 노출되는 상태만 관리자용 fixture id로 선언한다.
export const ADMIN_HOME_HERO_PREVIEW_GROUPS = [
  { id: 'academic', label: '학사 이벤트' },
  { id: 'day', label: '수업 하루' },
  { id: 'special', label: '특수 상태' },
]

export const ADMIN_HOME_HERO_PREVIEW_MODES = [
  { id: 'registration', label: '수강신청', description: '수강신청 D-Day · 실시간 카운트다운', group: 'academic' },
  { id: 'registration:semester-start', label: '개강 D-Day', description: '본수강신청 종료 후 개강 직전', group: 'academic' },
  { id: 'before-class:early', label: '새벽 첫 수업', description: '이른 시간 다음 수업 안내', group: 'day' },
  { id: 'commute-to-school', label: '등교', description: '등교 셔틀 안내', group: 'day' },
  { id: 'before-class:first-class', label: '수업 전', description: '첫 수업 시작 전 안내', group: 'day' },
  { id: 'in-class', label: '수업 중', description: '진행 중인 수업 안내', group: 'day' },
  { id: 'before-class:break', label: '쉬는 시간', description: '다음 수업까지 쉬는 시간', group: 'day' },
  { id: 'before-class:gap', label: '공강', description: '다음 수업까지 시간이 비어 있는 상태', group: 'day' },
  { id: 'lunch', label: '점심 / 학식', description: '점심 시간 학식 안내', group: 'day' },
  { id: 'shuttle-info', label: '일반 셔틀', description: '다음 셔틀 운행 안내', group: 'day' },
  { id: 'go-home', label: '하교', description: '귀가 셔틀 안내', group: 'day' },
  { id: 'day-done', label: '하루 마무리', description: '오늘 수업을 마친 뒤 안내', group: 'day' },
  { id: 'rest-day:weekday-no-class', label: '평일 수업 없음', description: '평일에 등록된 수업이 없는 상태', group: 'special' },
  { id: 'rest-day:weekend-no-class', label: '주말', description: '주말 수업 없음 상태', group: 'special' },
  { id: 'empty-timetable', label: '시간표 미등록', description: '시간표가 아직 등록되지 않은 상태', group: 'special' },
]

export function getAdminHomeHeroPreviewModes() {
  return ADMIN_HOME_HERO_PREVIEW_MODES.map(({ id, label }) => ({ id, label }))
}
